import api from "./Interceptor";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const getAllAppointments = async (
  page = 1,
  rowsPerPage,
  filterStatus,
  type = "appointment"
) => {
  try {
    const response = await api.get(
      `${BASE_URL}/appointment/all?page=${page}&limit=${rowsPerPage}&status=${filterStatus}&type=${type}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching appointments:", error);
    throw error?.response?.data || new Error("Failed to fetch appointments");
  }
};

export const getAppointmentDetails = async (appointmentId) => {
  try {
    const response = await api.get(`${BASE_URL}/appointment/${appointmentId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching appointment details:", error);
    throw (
      error?.response?.data || new Error("Failed to fetch appointment details")
    );
  }
};

export const updateAppointment = async (appointmentId, payload) => {
  try {
    const response = await api.put(`${BASE_URL}/appointment/${appointmentId}`, {
      ...payload,
      age: parseInt(payload.age),
    });
    return response.data;
  } catch (error) {
    console.error("Error updating appointment:", error);
    throw error?.response?.data || new Error("Failed to update appointment");
  }
};
